import React, { lazy, Suspense } from 'react';
import { IntlProvider, ReactIntlErrorCode } from 'react-intl';
import { useSelector } from 'react-redux';
import { Route, BrowserRouter as Router, Switch } from 'react-router-dom';
import AppLocale from './lang';
import { RootState } from './redux/store.interface';
import { buildRoutes } from './routes';
import { Route as IRoute } from './routes/route.interface';
import CheckClub from './shared/components/CheckClub';
import ClubHandler from './shared/components/Club';
import { loadingStyles } from './shared/styles';

const loading = (
  <div className="row" style={loadingStyles}>
    <div className="loader-bubble loader-bubble-info m-6"></div>
  </div>
);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function onError(e: any) {
  if ((e.code = ReactIntlErrorCode.MISSING_DATA)) {
    return;
  }
  console.error(e);
}

const App: React.FC = (): JSX.Element => {
  const locale = useSelector((state: RootState) => state.settings.lang);
  const club = useSelector((state: RootState) => state.club);
  const currentAppLocale = AppLocale[locale];

  return (
    <IntlProvider
      locale={locale}
      onError={onError}
      messages={currentAppLocale.messages}
      defaultRichTextElements={{
        // eslint-disable-next-line react/display-name
        b: chunks => <b>{chunks}</b>,
      }}>
      <Router>
        <Suspense fallback={loading}>
          <Switch>
            <Route path="/404" component={lazy(() => import('./pages/404'))} />
            <Route path="/inactive" component={lazy(() => import('./pages/Inactive'))} />
          </Switch>
        </Suspense>
        <ClubHandler>
          <CheckClub>
            {!!club && Object.keys(club).length ? (
              <Suspense fallback={loading}>
                <Switch>
                  {buildRoutes(club.landingPageSetting).menu.map((route: IRoute, idx: number) => (
                    <Route
                      key={idx}
                      exact={route.exact}
                      path={route.path}
                      component={route.component}
                    />
                  ))}
                  <Route path="*" component={lazy(() => import('./pages/InfoPage'))} />
                </Switch>
              </Suspense>
            ) : (
              <></>
            )}
          </CheckClub>
        </ClubHandler>
      </Router>
    </IntlProvider>
  );
};

export default App;
